<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        :title="title()"
        :large="true"
    >
        <div class="columns is-multiline is-tablet mb-1">
            <form-field
                class="column is-12"
                :error="errors.name"
                label="Titel"
            >
                <input-text
                    v-model="form.name"
                    :error="errors.name"
                />
            </form-field>
            <form-field
                class="column is-12"
                :error="errors.description"
                label="Standard beskrivelse"
            >
                <InputTextarea
                    v-model="form.description"
                    rows="8"
                />
            </form-field>
        </div>

        <template v-slot:footer>
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger is-flex-left" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="$emit('closed')">Annuller</button>
                    <button class="button is-primary" @click="submit">{{ saveButtonText }}</button>
                </div>

                <button class="button is-danger" @click="remove" v-if="isEdit">Slet</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputText, InputCheckbox, InputTextarea} from '@elems/form'

export default {
    components: {
        InputCheckbox,
        InputTextarea,
        Modal,
        FormField,
        InputText,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        selectedItem: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            errors: [],
            form: {
                name: '',
                description: '',
            },
        }
    },
    computed: {
        isEdit() {
            return this.selectedItem !== null
        },
        saveButtonText() {
            return this.isEdit ? 'Gem' : 'Opret'
        },
    },
    methods: {
        title() {
            return this.isEdit ? 'Rediger beskrivelse' : 'Opret beskrivelse'
        },
        submit() {
            return this.isEdit ? this.update() : this.create()
        },
        create() {
            window.axios.post('/api/default-descriptions', this.form)
                .then(({ data }) => {
                    this.$emit('created', data)
                    this.$store.dispatch('setSuccess', 'Standard Beskrivelse blev oprettet')
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors
                    }
                })
        },
        update() {
            window.axios.put('/api/default-descriptions/' + this.selectedItem.id, this.form)
                .then(({ data }) => {
                    this.$emit('updated', data)
                    this.$store.dispatch('setSuccess', 'Standard Beskrivelse blev opdateret')
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors
                    }
                })
        },
        reset() {
            if (this.isEdit) {
                this.form.name = this.selectedItem.name ? this.selectedItem.name : '';
                this.form.description = this.selectedItem.description ? this.selectedItem.description : '';
            } else {
                this.form.name = '';
                this.form.description = '';
            }
            this.errors = []
        },
        async remove() {
            if (!confirm('Er du sikker på du vil slette ' + this.form.name + '?')) {
                return
            }

            window.axios.delete('/api/default-descriptions/' + this.selectedItem.id)
                .then(() => {
                    this.$emit('deleted', this.selectedItem)
                    this.$store.dispatch('setSuccess', 'Dokumentgruppe blev slettet')
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Der skete en fejl')
                })
        },
    },
    watch: {
        active() {
            if (this.active) {
                this.reset()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.customer-details {
    h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #bbb;
        margin-bottom: 25px;
        cursor: pointer;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }


}

.column {
    padding: 0 0.75rem;
}
</style>
